export enum PriceQuoteStatus {
  PENDING = "pending",
  MATCHED = "matched",
  UNMATCHED = "unmatched",
  DISMISSED = "dismissed",
}

export interface PriceQuoteLineItem {
  id: number;
  priceQuoteId: number;
  requestedItemId: number | null;
  lineNumber: number | null;
  name: string | null;
  mfgName: string | null;
  partNumber: string | null;
  modelNumber: string | null;
  clientPartNumber: string | null;
  sku: string | null;
  actualPartNumber: string | null;
  quantity: number | null;
  unitOfMeasure: string | null;
  costEach: number | null;
  costOfManufactureCC: number | null;
  costOfShelfLifeCert: number | null;
  availability: string | null;
  estimatedFreight: number | null;
  freightZip: string | null;
  canShipOnClientsAcct: boolean | null;
  partNumOnProduct: boolean | null;
  partNumOnPackingSlip: boolean | null;
  quantityMinimums: string | null;
  additionalFees: string | null;
  paymentTerms: string | null;
  fobPoint: string | null;
  quoteExpirationDate: string | null;
  rawText: string | null;
}

export interface PriceQuote {
  id: number;
  emailId: number;
  rfqId: number | null;
  vendorId: number | null;
  vendorName: string | null;
  rfqReferenceNum: string | null;
  summary: string | null;
  status: PriceQuoteStatus;
  receivedDateTime: string;
  createdAt: string;
  subject?: string;
  from?: string;
  fromName?: string;
  lineItems: PriceQuoteLineItem[];
}

export default PriceQuote;
